/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { isEmpty } from "./size";

function concatText(entry: string, text: string) {
  return isEmpty(text) ? entry : entry.concat(" ", text);
}

export function generateActionSuccessText(item: string) {
  return (verb = "has been") => {
    return (action: string) => {
      return (rest = "") => {
        const baseText = `${item} ${verb} ${action}`;
        return `${concatText(baseText, rest)}.`;
      };
    };
  };
}

export function generateActionConfirmText(item: string) {
  return (action: string) => {
    return (rest = "") => {
      const baseText = `Are you sure you want to ${action} ${item}`;
      return `${concatText(baseText, rest)}?`;
    };
  };
}

export function inflect(singular: string, plural = `${singular}s`) {
  return (quantity: number) => (Math.abs(quantity) === 1 ? singular : plural);
}
